(function () {
  'use strict';

  // === MENSING FAMILY DEFINITIONS (im Uhrzeigersinn ab 12 Uhr) ===

  // 16 Familien auf dem Rad (Mai 2026, v6).
  // Gleichmäßige Verteilung: 360° / 16 = 22.5° pro Position, Radius 0.9.

  const MENSING_FAMILIES = [
    { id: 'fruchtig',      name: 'Fruchtig',      x:  0.000, y:  0.900, warmth:  0.15, facettes: ['Saftig', 'Reif', 'Leuchtend'],            emotions: ['Lebensfroh', 'Unbeschwert', 'Ausgelassen'] },
    { id: 'zitrisch',      name: 'Zitrisch',      x:  0.344, y:  0.831, warmth: -0.65, facettes: ['Spritzig', 'Prickelnd', 'Befreiend'],     emotions: ['Optimistisch', 'Wach', 'Aufgeschlossen'] },
    { id: 'aromatisch',    name: 'Aromatisch',    x:  0.636, y:  0.636, warmth: -0.15, facettes: ['Krautig', 'Botanisch', 'Fougère'],        emotions: ['Fokussiert', 'Vital', 'Tatkräftig'] },
    { id: 'aquatisch',     name: 'Aquatisch',     x:  0.831, y:  0.344, warmth: -0.55, facettes: ['Wässrig', 'Maritim', 'Mineralisch'],      emotions: ['Befreit', 'Klar', 'Ausgeglichen'] },
    { id: 'frisch',        name: 'Frisch',        x:  0.900, y:  0.000, warmth: -0.75, facettes: ['Kühl', 'Kristallin', 'Puristisch'],       emotions: ['Erfrischt', 'Leicht', 'Gelöst'] },
     { id: 'floral-klar',   name: 'Floral-klar',   x:  0.831, y: -0.344, warmth: -0.85, facettes: ['Luftig', 'Transparent', 'Schwebend'],     emotions: ['Heiter', 'Ungezwungen', 'Entspannt'] },
    { id: 'gruen',         name: 'Grün',          x:  0.636, y: -0.636, warmth: -0.30, facettes: ['Grün', 'Blättrig', 'Knackig'],            emotions: ['Zuversichtlich', 'Erholt', 'Geerdet'] },
    { id: 'floral',        name: 'Floral',        x:  0.344, y: -0.831, warmth: -0.05, facettes: ['Blumig', 'Elegant', 'Betörend'],          emotions: ['Anmutig', 'Zärtlich', 'Herzlich'] },
    { id: 'pudrig',        name: 'Pudrig',        x:  0.000, y: -0.900, warmth:  0.35, facettes: ['Pudrig', 'Samtig', 'Weich'],              emotions: ['Sanftmütig', 'Friedlich', 'Ruhig'] },
    { id: 'floriental',    name: 'Floriental',    x: -0.344, y: -0.831, warmth:  0.65, facettes: ['Üppig', 'Berauschend', 'Opulent'],        emotions: ['Sinnlich', 'Magnetisch', 'Hingebungsvoll'] },
    { id: 'milch-moschus', name: 'Milch-Moschus', x: -0.636, y: -0.636, warmth:  0.70, facettes: ['Milchig', 'Cremig', 'Hautnah'],           emotions: ['Geborgen', 'Behütet', 'Beschützt'] },
    { id: 'gourmand',      name: 'Gourmand',      x: -0.831, y: -0.344, warmth:  0.85, facettes: ['Süß', 'Vanillig', 'Sirupartig'],          emotions: ['Genussvoll', 'Verspielt', 'Verwöhnt'] },
    { id: 'orientalisch',  name: 'Amber',         x: -0.900, y:  0.000, warmth:  0.90, facettes: ['Harzig', 'Balsamisch', 'Orientalisch'],    emotions: ['Geheimnisvoll', 'Tiefgründig', 'Versunken'] },
    { id: 'wuerzig',       name: 'Würzig',        x: -0.831, y:  0.344, warmth:  0.55, facettes: ['Pfeffrig', 'Wärmend', 'Feurig'],          emotions: ['Selbstsicher', 'Mutig', 'Entschlossen'] },
    { id: 'holzig',        name: 'Holzig',        x: -0.636, y:  0.636, warmth:  0.30, facettes: ['Trocken', 'Warm', 'Rauchig'],             emotions: ['Stabil', 'Standhaft', 'Zentriert'] },
    { id: 'chypre',        name: 'Erdig-Ledrig',  x: -0.344, y:  0.831, warmth:  0.10, facettes: ['Herb', 'Moosig', 'Chypre'],               emotions: ['Souverän', 'Selbstbestimmt', 'Charismatisch'] },
  ];

  const PRESENCE_LABELS = {
    intim:     'Intim',
    moderat:   'Moderat',
    intensiv:  'Intensiv',
    statement: 'Statement',
  };

  // === LOCALIZATION (US English) ===
  // German is the source. When the storefront locale is English (window.FQ_LANG === 'en'),
  // family display names, facettes, emotions, presence labels and UI strings switch to US English.
  // Family IDs and the entire scoring engine stay untouched.

  const LANG = (typeof window !== 'undefined' && window.FQ_LANG === 'en') ? 'en' : 'de';

  const FAMILY_I18N_EN = {
    'fruchtig':      { name: 'Fruity',         facettes: ['Juicy', 'Ripe', 'Radiant'],          emotions: ['Joyful', 'Carefree', 'Exuberant'] },
    'zitrisch':      { name: 'Citrus',         facettes: ['Zesty', 'Sparkling', 'Liberating'],  emotions: ['Optimistic', 'Awake', 'Open'] },
    'aromatisch':    { name: 'Aromatic',       facettes: ['Herbal', 'Botanical', 'Fougère'],    emotions: ['Focused', 'Vital', 'Driven'] },
    'aquatisch':     { name: 'Aquatic',        facettes: ['Watery', 'Marine', 'Mineral'],       emotions: ['Liberated', 'Clear', 'Balanced'] },
    'frisch':        { name: 'Fresh',          facettes: ['Cool', 'Crystalline', 'Pure'],       emotions: ['Refreshed', 'Light', 'At ease'] },
    'floral-klar':   { name: 'Sheer Floral',   facettes: ['Airy', 'Translucent', 'Weightless'], emotions: ['Serene', 'Easygoing', 'Relaxed'] },
    'gruen':         { name: 'Green',          facettes: ['Green', 'Leafy', 'Crisp'],           emotions: ['Confident', 'Restored', 'Grounded'] },
    'floral':        { name: 'Floral',         facettes: ['Flowery', 'Elegant', 'Captivating'], emotions: ['Graceful', 'Tender', 'Warm'] },
    'pudrig':        { name: 'Powdery',        facettes: ['Powdery', 'Velvety', 'Soft'],        emotions: ['Gentle', 'Peaceful', 'Calm'] },
    'floriental':    { name: 'Floriental',     facettes: ['Lush', 'Intoxicating', 'Opulent'],   emotions: ['Sensual', 'Magnetic', 'Devoted'] },
    'milch-moschus': { name: 'Milk Musk',      facettes: ['Milky', 'Creamy', 'Skin-close'],     emotions: ['Secure', 'Sheltered', 'Protected'] },
    'gourmand':      { name: 'Gourmand',       facettes: ['Sweet', 'Vanilla', 'Syrupy'],        emotions: ['Indulgent', 'Playful', 'Pampered'] },
    'orientalisch':  { name: 'Amber',          facettes: ['Resinous', 'Balsamic', 'Oriental'],  emotions: ['Mysterious', 'Profound', 'Absorbed'] },
    'wuerzig':       { name: 'Spicy',          facettes: ['Peppery', 'Warming', 'Fiery'],       emotions: ['Self-assured', 'Bold', 'Determined'] },
    'holzig':        { name: 'Woody',          facettes: ['Dry', 'Warm', 'Smoky'],              emotions: ['Stable', 'Steadfast', 'Centered'] },
    'chypre':        { name: 'Earthy-Leather', facettes: ['Bracing', 'Mossy', 'Chypre'],        emotions: ['Commanding', 'Self-determined', 'Charismatic'] },
  };

  const PRESENCE_LABELS_EN = {
    intim:     'Intimate',
    moderat:   'Moderate',
    intensiv:  'Intense',
    statement: 'Statement',
  };

  const UI = (LANG === 'en')
    ? {
        progress: function (n, total) { return 'Step ' + n + ' of ' + total; },
        labelPrimary: 'Primary family', labelSecondary: 'Secondary families',
        labelPresence: 'Presence', labelCharacter: 'Scent character', labelEmotions: 'Emotional world',
        labelScores: 'Scores', warmth: 'Warmth', answers: 'Answers', questionAbbr: 'Q',
      }
    : {
        progress: function (n, total) { return 'Schritt ' + n + ' von ' + total; },
        labelPrimary: 'Primärfamilie', labelSecondary: 'Sekundärfamilien',
        labelPresence: 'Präsenz', labelCharacter: 'Duftcharakter', labelEmotions: 'Gefühlswelt',
        labelScores: 'Scores', warmth: 'Wärme', answers: 'Antworten', questionAbbr: 'F',
      };

  if (LANG === 'en') {
    MENSING_FAMILIES.forEach(function (fam) {
      const t = FAMILY_I18N_EN[fam.id];
      if (t) { fam.name = t.name; fam.facettes = t.facettes; fam.emotions = t.emotions; }
    });
    Object.keys(PRESENCE_LABELS_EN).forEach(function (k) { PRESENCE_LABELS[k] = PRESENCE_LABELS_EN[k]; });
  }

  const STORAGE_KEY     = 'heinsson-fragrance-quiz-v6-b2b-result';
  const STORAGE_TTL_MS  = 24 * 60 * 60 * 1000;
  const TRANSITION_EXIT_MS  = 250;
  const TRANSITION_ENTER_MS = 300;
  const TOTAL_STEPS     = 4;

  // === STATE ===

  let currentStep = 0;
  let answers = [];
  let lastProfile = null;

  // === DOM REFERENCES ===

  let section, progressBar, progressBarFill, progressLabel;
  let allSteps, stepMap;

  // === UTILITIES ===

  function sanitizeText(raw) {
    const div = document.createElement('div');
    div.textContent = raw;
    return div.innerHTML;
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function getStepEl(stepId) {
    return stepMap[String(stepId)];
  }

  function readScores(btn) {
    return {
      x:      parseFloat(btn.dataset.x      || '0'),
      y:      parseFloat(btn.dataset.y      || '0'),
      warmth: parseFloat(btn.dataset.warmth || '0'),
    };
  }

  function getOptionLabel(btn) {
    const labelEl = btn.querySelector('.fq-option__label');
    return labelEl ? labelEl.textContent.trim() : btn.textContent.trim();
  }

  // === SCORING ENGINE ===

  function computeProfile() {
    // Q1 (answers[0]) + Q2 (answers[1]): X/Y für Primärfamilie
    const totalsXY = { x: 0, y: 0 };
    for (let i = 0; i < 2; i++) {
      const answer = answers[i];
      if (!answer || !answer.scores) continue;
      totalsXY.x += answer.scores.x;
      totalsXY.y += answer.scores.y;
    }

    const normalized = {
      x: clamp(totalsXY.x, -1, 1),
      y: clamp(totalsXY.y, -1, 1),
    };

    // Q3 (answers[2]): Warmth für Sekundärfamilien-Reihenfolge
    const q3 = answers[2];
    const normalizedWarmth = clamp((q3 && q3.scores) ? q3.scores.warmth : 0, -1, 1);

    // Primary: 2D Euclidean (nur X/Y)
    const ranked = MENSING_FAMILIES.slice().map(function (family) {
      const dx = normalized.x - family.x;
      const dy = normalized.y - family.y;
      return { family, distance: Math.sqrt(dx * dx + dy * dy) };
    });
    ranked.sort(function (a, b) { return a.distance - b.distance; });

    // Sekundär: Die zwei Rad-Nachbarn der Primärfamilie (immer ein Trio)
    const primaryFamily = ranked[0].family;
    const primaryIndex  = MENSING_FAMILIES.indexOf(primaryFamily);
    const len           = MENSING_FAMILIES.length;
    const neighborA     = MENSING_FAMILIES[(primaryIndex - 1 + len) % len];
    const neighborB     = MENSING_FAMILIES[(primaryIndex + 1) % len];

    // Warmth bestimmt Reihenfolge: näher an User-Warmth kommt zuerst (→ Bridge-Text)
    const distA = Math.abs(normalizedWarmth - neighborA.warmth);
    const distB = Math.abs(normalizedWarmth - neighborB.warmth);
    const secondaries = distA <= distB ? [neighborA, neighborB] : [neighborB, neighborA];

    // Q4 (answers[3]) ist Präsenz — kein Scoring
    const q4Answer = answers[3];
    const presence = (q4Answer && q4Answer.presence) ? q4Answer.presence : 'moderat';

    return {
      primary:     primaryFamily,
      secondaries: secondaries,
      presence:    presence,
      scores:      { x: normalized.x, y: normalized.y, warmth: normalizedWarmth },
    };
  }

  // === PROGRESS BAR ===

  function updateProgress(stepNum) {
    const isResult = (stepNum === 'result');
    const isIntro  = (stepNum === 0);

    if (isIntro || isResult) {
      progressLabel.textContent = '';
      progressBarFill.style.width = isResult ? '100%' : '0%';
      progressBar.setAttribute('aria-valuenow', isResult ? TOTAL_STEPS : 0);
    } else {
      const pct = (stepNum / TOTAL_STEPS) * 100;
      progressBarFill.style.width = pct + '%';
      progressLabel.textContent = UI.progress(stepNum, TOTAL_STEPS);
      progressBar.setAttribute('aria-valuenow', stepNum);
    }
  }

  // === STEP TRANSITION ===

  function transitionTo(nextStepId) {
    const currentStepEl = getStepEl(currentStep);
    const nextStepEl    = getStepEl(nextStepId);
    if (!nextStepEl) return;

    currentStepEl.classList.add('fq-step--exiting');

    setTimeout(function () {
      currentStepEl.classList.remove('fq-step--active', 'fq-step--exiting');
      currentStepEl.hidden = true;

      nextStepEl.hidden = false;
      nextStepEl.classList.add('fq-step--active', 'fq-step--entering');

      setTimeout(function () {
        nextStepEl.classList.remove('fq-step--entering');
      }, TRANSITION_ENTER_MS);

      currentStep = nextStepId;
      updateProgress(currentStep);
    }, TRANSITION_EXIT_MS);
  }

  // === ANSWER STATE HELPERS ===

  function clearStepSelection(stepNum) {
    const stepEl = getStepEl(stepNum);
    if (!stepEl) return;
    stepEl.querySelectorAll('.fq-option--selected').forEach(function (btn) {
      btn.classList.remove('fq-option--selected');
    });
  }

  function restoreStepSelection(stepNum) {
    const answer = answers[stepNum - 1];
    if (!answer || !answer.btn) return;
    const stepEl = getStepEl(stepNum);
    if (!stepEl) return;
    answer.btn.classList.add('fq-option--selected');
  }

  // === RESULT RENDERING ===

  function renderResult(profile) {
    const profiles = window.FRAGRANCE_QUIZ_PROFILES;

    const primaryEl   = document.querySelector('[data-result="primary"]');
    const secondaryEl = document.querySelector('[data-result="secondary"]');
    const facettesEl  = document.querySelector('[data-result="facettes"]');
    const emotionsEl  = document.querySelector('[data-result="emotions"]');
    const descEl      = document.querySelector('[data-result="description"]');

    if (primaryEl)   primaryEl.textContent   = profile.primary.name;
    if (secondaryEl) secondaryEl.textContent = profile.secondaries[0].name + ' · ' + profile.secondaries[1].name;

    if (facettesEl) {
      const prim = profile.primary.facettes || [];
      let sec = [];
      profile.secondaries.forEach(function(s) {
        (s.facettes || []).forEach(function(f) {
          if (prim.indexOf(f) === -1 && sec.indexOf(f) === -1) sec.push(f);
        });
      });
      const primHTML = prim.map(function(f) {
        return '<span class="fq-pill fq-pill--primary">' + sanitizeText(f) + '</span>';
      }).join('');
      const secHTML = sec.length
        ? '<div class="fq-pills__row fq-pills__row--secondary">' +
          sec.map(function(f) {
            return '<span class="fq-pill fq-pill--secondary">' + sanitizeText(f) + '</span>';
          }).join('') + '</div>'
        : '';
      facettesEl.innerHTML = '<div class="fq-pills__row">' + primHTML + '</div>' + secHTML;
    }

    if (emotionsEl) {
      const prim = profile.primary.emotions || [];
      let sec = [];
      profile.secondaries.forEach(function(s) {
        (s.emotions || []).forEach(function(e) {
          if (prim.indexOf(e) === -1 && sec.indexOf(e) === -1) sec.push(e);
        });
      });
      const primHTML = prim.map(function(e) {
        return '<span class="fq-pill fq-pill--primary">' + sanitizeText(e) + '</span>';
      }).join('');
      const secHTML = sec.length
        ? '<div class="fq-pills__row fq-pills__row--secondary">' +
          sec.map(function(e) {
            return '<span class="fq-pill fq-pill--secondary">' + sanitizeText(e) + '</span>';
          }).join('') + '</div>'
        : '';
      emotionsEl.innerHTML = '<div class="fq-pills__row">' + primHTML + '</div>' + secHTML;
    }

    if (!profiles) return;

    if (descEl) {
      const intro      = profiles.intro[profile.primary.id] || '';
      const bridgeKey  = profile.primary.id + '→' + profile.secondaries[0].id;
      const bridge     = profiles.bridge[bridgeKey] || '';
      const presenceTx = profiles.presence[profile.presence] || '';
      descEl.textContent = [intro, bridge, presenceTx].filter(Boolean).join(' ');
    }
  }

  // === BRIEFING FORM ===

  function populateBriefingForm(profile) {
    const hiddenField  = document.getElementById('fq-hidden-profile');
    const summaryField = document.getElementById('fq-form-summary');
    if (!hiddenField || !summaryField) return;

    let allFacettes = (profile.primary.facettes || []).slice();
    profile.secondaries.forEach(function(s) {
      (s.facettes || []).forEach(function(f) {
        if (allFacettes.indexOf(f) === -1) allFacettes.push(f);
      });
    });
    let allEmotions = (profile.primary.emotions || []).slice();
    profile.secondaries.forEach(function(s) {
      (s.emotions || []).forEach(function(e) {
        if (allEmotions.indexOf(e) === -1) allEmotions.push(e);
      });
    });

    const secondaryNames = profile.secondaries.map(function(s) { return s.name; }).join(', ');

    const answerSummary = answers.map(function (a, i) {
      const labels = a ? (a.labels || []).map(function (l) { return sanitizeText(l); }) : [];
      return UI.questionAbbr + (i + 1) + ': ' + (labels.join(', ') || '—');
    }).join(' | ');

    hiddenField.value = [
      UI.labelPrimary + ': '   + profile.primary.name,
      UI.labelSecondary + ': ' + secondaryNames,
      UI.labelPresence + ': '  + (PRESENCE_LABELS[profile.presence] || profile.presence),
      UI.labelCharacter + ': ' + allFacettes.join(', '),
      UI.labelEmotions + ': '  + allEmotions.join(', '),
      UI.labelScores + ': X='  + profile.scores.x.toFixed(2)
        + ' Y='                + profile.scores.y.toFixed(2)
        + ' ' + UI.warmth + '='+ profile.scores.warmth.toFixed(2),
      UI.answers + ': '        + answerSummary,
    ].join('\n');

    summaryField.innerHTML =
      '<dl>' +
      '<dt>' + UI.labelPrimary   + '</dt><dd>' + sanitizeText(profile.primary.name) + '</dd>' +
      '<dt>' + UI.labelSecondary + '</dt><dd>' + sanitizeText(secondaryNames)       + '</dd>' +
      '<dt>' + UI.labelPresence  + '</dt><dd>' + sanitizeText(PRESENCE_LABELS[profile.presence] || profile.presence) + '</dd>' +
      '<dt>' + UI.labelCharacter + '</dt><dd>' + sanitizeText(allFacettes.join(' · ')) + '</dd>' +
      '<dt>' + UI.labelEmotions  + '</dt><dd>' + sanitizeText(allEmotions.join(' · ')) + '</dd>' +
      '</dl>';
  }

  // === LOCALSTORAGE PERSISTENCE ===

  function saveResult(profile) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        primary:     profile.primary.id,
        secondaries: profile.secondaries.map(function(s) { return s.id; }),
        presence:  profile.presence,
        scores:    profile.scores,
        answers:   answers.map(function (a) {
          if (!a) return null;
          return { scores: a.scores || null, presence: a.presence || null, labels: a.labels || [] };
        }),
        timestamp: Date.now(),
      }));
    } catch (e) {}
  }

  function loadSavedResult() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data || !data.timestamp) return null;
      if (Date.now() - data.timestamp > STORAGE_TTL_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      const primary = MENSING_FAMILIES.find(function (f) { return f.id === data.primary; });
      if (!primary || !data.secondaries || !Array.isArray(data.secondaries)) return null;
      const secondaries = data.secondaries.map(function(id) {
        return MENSING_FAMILIES.find(function (f) { return f.id === id; });
      });
      if (secondaries.length !== 2 || !secondaries[0] || !secondaries[1]) return null;
      if (data.answers) answers = data.answers;
      return { primary: primary, secondaries: secondaries, presence: data.presence, scores: data.scores };
    } catch (e) {
      return null;
    }
  }

  // === SHOW RESULT SCREEN ===

  function showResult(profile) {
    lastProfile = profile;
    renderResult(profile);
    saveResult(profile);
    transitionTo('result');
  }

  // === RESTART ===

  function restartQuiz() {
    localStorage.removeItem(STORAGE_KEY);

    if (window.location.search.includes('contact_posted=true') || document.querySelector('.fq-form-success')) {
      window.location.href = window.location.pathname;
      return;
    }

    answers     = [];
    lastProfile = null;

    section.querySelectorAll('[data-result]').forEach(function (el) {
      el.textContent = '';
      el.innerHTML   = '';
    });

    allSteps.forEach(function (stepEl) {
      stepEl.classList.remove('fq-step--active', 'fq-step--entering', 'fq-step--exiting');
      stepEl.hidden = true;
      stepEl.querySelectorAll('.fq-option--selected').forEach(function (btn) {
        btn.classList.remove('fq-option--selected');
      });
    });

    const introStep = getStepEl(0);
    if (introStep) {
      introStep.hidden = false;
      introStep.classList.add('fq-step--active');
    }

    currentStep = 0;
    updateProgress(0);

    const briefingForm = document.getElementById('fq-briefing-form');
    if (briefingForm) briefingForm.style.display = 'none';

    const showFormBtn = document.getElementById('fq-show-form');
    if (showFormBtn) showFormBtn.setAttribute('aria-expanded', 'false');
  }

  // === OPTION CLICK HANDLER ===

  function handleOptionClick(btn, stepEl) {
    const stepNum = parseInt(stepEl.dataset.step, 10);

    // Deselect any previous selection in this step
    stepEl.querySelectorAll('.fq-option--selected').forEach(function (b) {
      b.classList.remove('fq-option--selected');
    });
    btn.classList.add('fq-option--selected');

    const label = getOptionLabel(btn);

    if (stepNum === 4) {
      // Q4: Präsenz — nur qualitativ, kein Scoring, löst Ergebnisberechnung aus
      answers[3] = {
        presence: btn.dataset.presence || 'moderat',
        labels:   [label],
        btn:      btn,
      };
      showResult(computeProfile());
      return;
    }

    // Q1–Q4: Scoring
    answers[stepNum - 1] = {
      scores: readScores(btn),
      labels: [label],
      btn:    btn,
    };
    transitionTo(stepNum + 1);
  }

  // === BACK NAVIGATION ===

  function handleBack(stepEl) {
    const stepNum    = parseInt(stepEl.dataset.step, 10);
    const prevStep   = stepNum - 1;
    const prevStepEl = getStepEl(prevStep);
    if (!prevStepEl) return;

    answers[stepNum - 1] = undefined;
    clearStepSelection(stepNum);

    const currentStepEl = getStepEl(currentStep);
    currentStepEl.classList.add('fq-step--exiting');

    setTimeout(function () {
      currentStepEl.classList.remove('fq-step--active', 'fq-step--exiting');
      currentStepEl.hidden = true;

      prevStepEl.hidden = false;
      prevStepEl.classList.add('fq-step--active', 'fq-step--entering');

      setTimeout(function () {
        prevStepEl.classList.remove('fq-step--entering');
      }, TRANSITION_ENTER_MS);

      currentStep = prevStep;
      updateProgress(currentStep);
      restoreStepSelection(prevStep);
    }, TRANSITION_EXIT_MS);
  }

  // === BRIEFING FORM TOGGLE ===

  function handleShowForm() {
    const formEl  = document.getElementById('fq-briefing-form');
    const showBtn = document.getElementById('fq-show-form');
    if (!formEl || !showBtn) return;

    const isVisible = formEl.style.display !== 'none';
    if (isVisible) {
      formEl.style.display = 'none';
      showBtn.setAttribute('aria-expanded', 'false');
    } else {
      formEl.style.display = 'block';
      showBtn.setAttribute('aria-expanded', 'true');
      if (lastProfile) populateBriefingForm(lastProfile);
      formEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // === EVENT DELEGATION ===

  function handleSectionClick(event) {
    const target = event.target;

    if (target.id === 'fq-start' || target.closest('#fq-start')) {
      transitionTo(1);
      return;
    }
    if (target.id === 'fq-restart' || target.closest('#fq-restart')) {
      restartQuiz();
      return;
    }
    if (target.id === 'fq-show-form' || target.closest('#fq-show-form')) {
      handleShowForm();
      return;
    }

    const backBtn = target.classList.contains('fq-back') ? target : target.closest('.fq-back');
    if (backBtn) {
      const stepEl = backBtn.closest('[data-step]');
      if (stepEl) handleBack(stepEl);
      return;
    }

    const optionBtn = target.classList.contains('fq-option') ? target : target.closest('.fq-option');
    if (optionBtn) {
      const stepEl = optionBtn.closest('[data-step]');
      if (stepEl) handleOptionClick(optionBtn, stepEl);
    }
  }

  // === INITIALISATION ===

  function init() {
    section = document.getElementById('fragrance-quiz');
    if (!section) return;

    progressBar     = section.querySelector('.fq-progress');
    progressBarFill = section.querySelector('.fq-progress__bar');
    progressLabel   = section.querySelector('.fq-progress__label');

    allSteps = Array.from(section.querySelectorAll('[data-step]'));
    stepMap  = {};
    allSteps.forEach(function (el) { stepMap[el.dataset.step] = el; });

    const savedProfile = loadSavedResult();
    if (savedProfile) {
      const introStep = getStepEl(0);
      if (introStep) { introStep.classList.remove('fq-step--active'); introStep.hidden = true; }

      lastProfile = savedProfile;
      renderResult(savedProfile);

      const resultStep = getStepEl('result');
      if (resultStep) { resultStep.hidden = false; resultStep.classList.add('fq-step--active'); }

      currentStep = 'result';
      updateProgress('result');

      const formSuccess = document.querySelector('.fq-form-success');
      const formError   = document.querySelector('.fq-form-error');
      if (formSuccess || formError || window.location.search.includes('contact_posted=true')) {
        const formEl  = document.getElementById('fq-briefing-form');
        const showBtn = document.getElementById('fq-show-form');
        if (formEl) {
          formEl.style.display = 'block';
          setTimeout(function () { formEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 100);
        }
        if (showBtn) showBtn.setAttribute('aria-expanded', 'true');
      }
    }

    section.addEventListener('click', handleSectionClick);
    checkHashAndScroll();
  }

  function checkHashAndScroll() {
    const hash = window.location.hash;
    if (hash === '#duftprofil' || hash === '#duftquiz' || hash === '#fragrance-quiz') {
      const target = document.getElementById('fragrance-quiz');
      if (target) {
        setTimeout(function () {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 400);
      }
    }
  }

  // === ENTRY POINT ===

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('hashchange', checkHashAndScroll);
  window.addEventListener('load', checkHashAndScroll);

}());
